import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=810f655c&"
import script from "./Season.vue?vue&type=script&lang=js&"
export * from "./Season.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Season.vue"
export default component.exports